// Date + guest-list helpers for guest-facing forms.

/**
 * Format an ISO date or datetime as M/D/YYYY, timezone-safe. Plain
 * 'yyyy-mm-dd' and full ISO datetimes render by their date parts (no Date
 * math, no UTC/local shift). Unparseable input is returned as-is instead of
 * rendering NaN/NaN/NaN (session 30: a real-Date sheet cell leaked a full
 * ISO datetime into the arrival-link token payload and the old parser
 * produced NaN dates on the arrival form).
 */
export function fmtDate(iso) {
  if (!iso) return "";
  const s = String(iso);
  const m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (m) return Number(m[2]) + "/" + Number(m[3]) + "/" + m[1];
  try {
    const d = new Date(s);
    if (!isNaN(d.getTime())) {
      return d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
    }
  } catch {
    /* fall through to the raw string */
  }
  return s;
}

/**
 * Parse the Master row's `guest_list` JSON into form guests [{name, age}].
 * Returns [] on blank/invalid input — the caller keeps its adults/children
 * skeleton instead.
 */
export function parseGuestList(json) {
  if (!json) return [];
  try {
    const gl = JSON.parse(json);
    if (!Array.isArray(gl)) return [];
    return gl
      .filter((g) => g && typeof g === "object")
      .map((g) => ({ name: String(g.name || ""), age: String(g.age || "18+") }));
  } catch {
    return [];
  }
}
